import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { WallboardsApiModel, WallboardSlide, TypeStateApiModel } from 'src/app/wallboards/wallboards.model';

@Injectable({
    providedIn: 'root'
})
export class LaunchWallboardService {
    constructor(
        private cvApiService: CVApiService
    ) { }

    public async loadWallboards(): Promise<WallboardsApiModel> {
        try {
            let response = await this.cvApiService.get<WallboardsApiModel>("/api/v1/wallboards");
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else
                throw response;
        }
        catch (error) {
            console.error('Failed to load wallboards.')
        }
    }

    public async loadIndividualWallboard(wallboardId): Promise<WallboardSlide[]> {
        try {
            let response = await this.cvApiService.get<WallboardSlide[]>(`/api/v1/wallboardInfo/${wallboardId}/-1`);
            if(response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else
                throw response;
        }
        catch (error) {
            console.error('Failed to load wallboard: ' + wallboardId);
        }
    }

    public async loadTypeState(slideTypeId: number, slideKey: string, creatorId: number): Promise<TypeStateApiModel> {
        try {
            let response = await this.cvApiService.post<TypeStateApiModel>(`/api/v1/typeState/${slideTypeId}/${creatorId}`, JSON.stringify(slideKey));
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else
                throw response;
        }
        catch (error) {
            console.error(`Failed to load type state for ${slideTypeId}, key ${slideKey}.`);
        }
    }

    /**
     * Opens wallboard preview in new page.
     * @param wallboardId ID of wallboard to open
     */
    public openWallboardPreview(wallboardId: number) {
        window.open(`../Admin/WallboardView.aspx?wid=${wallboardId}`, "_blank");
    }
}
